module.exports = __webpack_public_path__ + "PC/img/tob-wechat.6e173abf.png";